/*@flow*/
import * as c from 'lib/constants';
import store from 'store';

export default (path: string | Function, value: any) => {
  if (typeof path === 'function') {
    value = path(store.getState());
    path = '';
  }
  store.dispatch({ type: c.SET_RECORD, payload: { path, value } });
};
